import { Box } from '@mui/material';

type BrandLogoVariant = 'full' | 'icon';

interface BrandLogoProps {
  readonly variant?: BrandLogoVariant;
  readonly height?: number;
}

export default function BrandLogo({ variant = 'full', height = 36 }: BrandLogoProps) {
  const src = variant === 'icon' ? '/branding/privaface-logo-mark.svg' : '/branding/privaface-logo-full.svg';
  const alt = variant === 'icon' ? 'Privaface icon' : 'Privaface';

  return (
    <Box
      component="img"
      src={src}
      alt={alt}
      sx={{
        height,
        width: 'auto',
        maxWidth: '100%',
        objectFit: 'contain',
        display: 'block',
      }}
    />
  );
}
